
import { useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Progress } from "@/components/ui/progress";
import { CheckCircle, Play } from "lucide-react";

interface LessonType {
  id: string;
  title: string;
  duration: string;
  video_id: string;
  pdf_url?: string;
  isCompleted: boolean;
}

interface ModuleType {
  id: string;
  title: string;
  lessons: LessonType[];
}

interface CourseProgressProps {
  modulesList: ModuleType[];
  courseId: string;
  activeVideoId: string | null;
  userProgress: number;
  onLessonSelect: (lesson: LessonType) => void;
}

const CourseProgress = ({ 
  modulesList, 
  courseId, 
  activeVideoId, 
  userProgress, 
  onLessonSelect 
}: CourseProgressProps) => {
  return (
    <div className="sticky top-24 border rounded-lg p-5">
      <h2 className="text-lg font-medium mb-4">Kursuse progress</h2>
      
      <div className="mb-6">
        <div className="flex justify-between text-sm mb-1">
          <span>Üldine progress</span>
          <span>{userProgress || 0}%</span>
        </div>
        <Progress value={userProgress || 0} className="h-2" />
      </div>
      
      <div className="space-y-4">
        {modulesList.map((module) => (
          <div key={module.id} className="space-y-2">
            <h3 className="font-medium">{module.title}</h3>
            <ul className="space-y-1">
              {module.lessons.map((lesson) => (
                <li key={lesson.id}>
                  <button 
                    onClick={() => onLessonSelect(lesson)}
                    className={`flex items-center w-full py-1.5 px-2 rounded-md text-sm text-left ${
                      activeVideoId === lesson.video_id 
                        ? 'bg-kaija-accent text-white' 
                        : lesson.isCompleted
                        ? 'text-green-600 hover:bg-gray-50' 
                        : 'text-gray-700 hover:bg-gray-50'
                    }`}
                  >
                    {lesson.isCompleted ? (
                      <CheckCircle className="h-4 w-4 mr-2 flex-shrink-0" />
                    ) : (
                      <Play className="h-4 w-4 mr-2 flex-shrink-0" />
                    )}
                    <span className="truncate">{lesson.title}</span>
                    <span className="ml-auto text-xs opacity-70">{lesson.duration}</span>
                  </button>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      
      <div className="mt-6 pt-4 border-t">
        <Button
          className="w-full"
          variant="outline"
          asChild
        >
          <Link to="/my-courses">Minu kursused</Link>
        </Button>
      </div>
    </div>
  );
};

export default CourseProgress;
